<template>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Año</th>
        <th scope="col">Equipos de Trabajo</th>
        <th scope="col">Numero de personas por Equipo de Trabajo</th>
        <th scope="col">
          Nº de metas de Gestión comprometidas por Equipo de Trabajo
        </th>
        <th scope="col">Porcentaje de Cumplimiento de Metas</th>
        <th scope="col">Incremento por Desempeño Colectivo</th>

        <th scope="col">
          <b-button v-if="!readOnly" class="button-add" @click="addItemList">+</b-button>
        </th>
      </tr>
    </thead>
    <tbody>
      <Row
        v-for="(item, index) in itemList"
        :key="index"
        :removeItem="removeItem"
        :objTest="item"
        :readOnly="readOnly"
      />
    </tbody>
  </table>
</template>

<script>
import Row from "./Row.vue";
export default {
  components: {
    Row,
  },
  props: ["itemList", "removeItem", "addItemList", "readOnly"],
};
</script>

<style scoped>
.titulo-c3 {
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 10px 15px;
}
.table > tbody,
.table > thead {
  vertical-align: middle;
}
.table {
  border: 1px solid #ccc;
}
.button-add {
  background: #25a2b7 !important;
  color: white !important;
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 14px;
  padding: 0 !important;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 0;
}
</style>
